import Vue from 'vue'
import Router from 'vue-router'
import baseRouter from './baseRouter'
import corporation from './corporation'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: 'api-pc',
  routes: []
    .concat(baseRouter)
    .concat(corporation),
  scrollBehavior(to, from, savedPosition) {
    return {x: 0, y: 0}
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js